import React, { useContext } from "react";
import { ReadOnlyContext } from "../ReadOnlyContext";

/**
 * Polished select field — same props API, better visual.
 */
function CustomSelect({
  value,
  onChange,
  placeHolder = "Select option",
  label,
  options = [],
  name,
  disabled,
  ...rest
}) {
  const isReadOnly = useContext(ReadOnlyContext);
  const isDisabled = disabled !== undefined ? disabled : isReadOnly;

  return (
    <div style={{ width: "100%" }}>
      {label && (
        <label
          style={{
            display     : "block",
            marginBottom: 5,
            fontWeight  : 600,
            fontSize    : 12,
            color       : "#374151",
            letterSpacing: ".01em",
          }}
        >
          {label}
        </label>
      )}
      <select
        name={name}
        value={value}
        onChange={onChange}
        disabled={isDisabled}
        style={{
          display      : "block",
          width        : "100%",
          border       : "1.5px solid #cbd5e1", // Slate border
          borderRadius : 8,
          padding      : "8px 11px",
          fontSize     : 13,
          color        : "#0f172a", // Slate text
          background   : "#fff",
          outline      : "none",
          cursor       : "pointer",
          transition   : "border-color .14s, box-shadow .14s",
          fontFamily   : "inherit",
          lineHeight   : 1.5,
          appearance   : "auto",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#024e5a"; // Brand Deep Teal
          e.target.style.boxShadow   = "0 0 0 3px rgba(2, 78, 90, 0.15)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#cbd5e1";
          e.target.style.boxShadow   = "none";
        }}
        {...rest}
      >
        <option value="" disabled>
          {placeHolder}
        </option>
        {options?.map((item, i) => (
          <option key={i} value={item?.value}>
            {item?.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CustomSelect;
